import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

const Toggle = ({ value, onToggle }) => {
  return (
    <button
      className={classNames('border-2 border-transparent cursor-pointer duration-200 ease-in-out flex-shrink-0 h-6 inline-flex relative rounded-full transition-colors w-11 focus:outline-none focus:shadow-outline sm:h-7 sm:w-14 lg:h-8 lg:w-16', {
        'bg-green-400': value,
        'bg-gray-200': !value
      })}
      tabIndex='0'
      onClick={() => { onToggle() }}
    >
      <span
        className={classNames('bg-white duration-200 ease-in-out h-5 inline-block rounded-full shadow transform transition w-5 sm:h-6 sm:w-6 lg:h-7 lg:w-7', {
          'translate-x-5 sm:translate-x-7 lg:translate-x-8': value,
          'translate-x-0': !value
        })}
        aria-hidden='true'
      />
    </button>
  )
}

Toggle.propTypes = {
  value: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
}

export default Toggle
